import { render } from "./events.vue?vue&type=template&id=e1063234&scoped=true"
import script from "./events.vue?vue&type=script&lang=js"
export * from "./events.vue?vue&type=script&lang=js"

import "./events.vue?vue&type=style&index=0&id=e1063234&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e1063234"

export default script